// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="organizations">
//   <h1 data-target="organizations.output"></h1>
// </div>

import { Controller } from "stimulus";
import swal from 'sweetalert';
import Rails from '@rails/ujs';
import QrCode from "qrcode-generator"
import QrCd from "easyqrcodejs"

import "../customs/bootstrap-tagsinput"


export default class extends Controller {
  static targets = ["paymentTemplete", "customFieldTemplate", "templateFields"]

  link = ""
  qrInterval = null
  
  connect() {
    if (document.getElementById("qrcode")) {
      this.requestQR()
    }
    
    // Aplicar máscaras apenas se os elementos existirem
    const organizationCnpj = document.getElementById("organization_cnpj");
    if (organizationCnpj) {
      new Inputmask("99.999.999/9999-99").mask(organizationCnpj);
    }
    
    const amountField = document.getElementById("amount");
    if (amountField) {
      new Inputmask("[9][9][9][9][9][9]").mask(amountField);
    }
    
    // Máscara de valor para o campo amount-input
    const amountInput = document.getElementById("amount-input");
    if (amountInput) {
      new Inputmask({
        alias: 'currency',
        prefix: '',
        suffix: '',
        radixPoint: ',',
        groupSeparator: '.',
        numericInput: true,
        rightAlign: false
      }).mask(amountInput);
      
      // Adicionar event listener para mudanças de valor
      amountInput.addEventListener('input', this.changeAmount.bind(this));
    }
    
    // Configurar QR Code para link externo
    const externLinkField = document.getElementById("extern_link");
    if (externLinkField) {
      this.link = externLinkField.value;
      if (this.link && document.getElementById('placeHolder')) {
        // Aguardar logo carregar antes de gerar QR Code
        const logoElement = document.getElementById("logo");
        if (logoElement && !logoElement.complete) {
          logoElement.addEventListener('load', () => {
            this.makeQR(this.link);
          });
          // Fallback: gerar QR Code após 2 segundos mesmo se logo não carregar
          setTimeout(() => {
            if (!logoElement.complete) {
              this.makeQR(this.link);
            }
          }, 2000);
        } else {
          this.makeQR(this.link); // Gerar QR Code inicial
        }
      }
    }
    
    // Inicializar tagsinput apenas se jQuery estiver disponível
    if (typeof $ !== 'undefined' && $('.taginput').length > 0) {
      $('.taginput').tagsinput();
    }
  }
  
  copy(e) {
    const externLinkField = document.getElementById("extern_link");
    if (externLinkField) {
      externLinkField.select();
      document.execCommand("copy");
    }
    e.preventDefault();
  }

  requestQR() {
    this.qrInterval = setInterval(() => {
      fetch(`/organizations/whatsapp_qrcode`).then((response) => {
        response.json().then((data) => {
          if (data.success) {
            document.getElementById("qrcode").src = data.qrcode
          }
          if (data.reload) {
            console.log('Reloading')
            clearInterval(this.qrInterval)
            window.location.reload()
          }
        })
      })
    }, 500)
  }
  
  changeAmount(e) {
    try {
      const externLinkField = document.getElementById("extern_link");
      const amountValue = e.currentTarget.value.replace(/[^\d,]/g, '').replace(',', '.');
      
      if (externLinkField && this.link) {
        // Remove parâmetro amount existente e adiciona o novo
        const baseUrl = this.link.split('?')[0];
        const newUrl = amountValue ? `${baseUrl}?amount=${amountValue}` : baseUrl;
        
        externLinkField.value = newUrl;
        
        // Verificar se o placeholder existe antes de gerar o QR Code
        if (document.getElementById('placeHolder')) {
          this.makeQR(newUrl);
        }
      }
    } catch (error) {
      console.error('Erro ao alterar valor do QR Code:', error);
    }
  }
  
  setupAmountChange() {
    var amountInput = document.getElementById('amount-input');
    var externLink = document.getElementById('extern-link');
    var makeQR = this.makeQR.bind(this);

    function changeAmount(e) {
      var amountValue = amountInput.value.replace(',', '.');
      var newExternLink = `${externLink.value.split('?')[0]}?amount=${amountValue}`;
      externLink.value = newExternLink;
      makeQR(newExternLink);
    }
    amountInput.addEventListener('input', changeAmount);
  }

  add_custom_field(event) {
    event.preventDefault()
    this.templateFieldsTarget.insertAdjacentHTML("beforebegin", this.customFieldTemplateTarget.innerHTML)
    $('.taginput').tagsinput();
  }
  
  change_type(event) {
    if (event.target.value == "select"){
      event.target.closest(".nested-fields").querySelector('.taginput').disabled = false
      event.target.closest(".nested-fields").querySelector('.taginput--selector').style.display = 'initial'
    } else {
      event.target.closest(".nested-fields").querySelector('.taginput--selector').style.display = 'none'
      event.target.closest(".nested-fields").querySelector('.taginput').disabled = true
    }
  }
  
  remove_association(event) {
    event.preventDefault()
    // console.log(event.target.closest(".nested-fields").target.childNodes())
    event.target.closest(".nested-fields").remove()
  }

  makeQR(data) {
    const placeHolder = document.getElementById('placeHolder');
    if (!placeHolder) return;
    
    placeHolder.innerHTML = "";
    
    const logoElement = document.getElementById("logo");
    const organizationName = document.querySelector('[name="organization[trading_name]"]')?.value || "Econekta";
    
    // Preparar configuração do QR Code
    const qrConfig = {
      text: data,
      width: 350,
      height: 350,
      colorLight: "#FFF8EB",
      colorDark: "#1c354c",
      dotScale: 1,
      quietZone: 12,
      quietZoneColor: "#54c7c3",
      title: organizationName,
      titleTop: 20,
      titleColor: "#FFF",
      titleBackgroundColor: "#54c7c3",
      titleHeight: 32,
      titleFont: "bold 25px Arial",
    };
    
    // Adicionar logo apenas se existir e estiver carregado
    if (logoElement && logoElement.complete && logoElement.naturalHeight > 0) {
      // Verificar se é uma URL válida
      try {
        const logoUrl = logoElement.src;
        if (logoUrl && logoUrl !== '' && !logoUrl.endsWith('null')) {
          qrConfig.logo = logoUrl;
          qrConfig.logoWidth = 80;
          qrConfig.logoHeight = 80;
          qrConfig.logoBackgroundTransparent = true;
        }
      } catch (error) {
        console.warn('Logo não pôde ser adicionado ao QR Code:', error);
      }
    }
    
    var qr = new QrCd(placeHolder, qrConfig);
  }

}
